import { GlobalsVariables } from "src/utils/constants";

export class PlannerAction {
  constructor() {
    if (new.target === PlannerAction) {
      throw new TypeError("Cannot construct abstract instances directly");
    }
    this.actionName = "Action";
    this.debug = GlobalsVariables.env === "dev";
    this.error = false;
  }
  execute(callback) { }
  undo(callback) { }
  roomIdChanged(from, to) { }
  deviceIdChanged(from, to) { }
  serialIdChanged(from, to) { }
  serialConnectionIdChanged(from, to) { }
  noteIdChanged(from, to) { }
  measurementIdChanged(from, to) { }
  wallModConnIdChanged(from, to) { }
  wallModIdChanged(from, to) { }
  wallIdChanged(from, to) { }
  equalAsString(a, b) {
    if (this.debug && (typeof a === "undefined" || typeof b === "undefined")) {
      console.warn("HISTORY: received undefined argument for comparison");
    }
    return ("" + a) === ("" + b);
  }
}